export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const LOGO_URL = `${BACKEND}/api/files/veneer-export/products/3fb83a1d-3e4a-466f-8c37-9fb61a377e5a.png`;

// Ürün görselinin (sitede gösterilen işlenmiş hali) markalı PDF indirme bağlantısı
export const productPdfUrl = (product, lang = "tr") => `${API}/products/${product.id}/pdf?lang=${lang}`;

// Yüklenen görseller /api/files/... döner; harici URL'ler http ile başlar.
export const imageUrl = (img) => {
  if (!img) return "";
  if (img.startsWith("http")) return img;
  return `${BACKEND}${img}`;
};

// Liste sayfaları için küçük/hafif thumbnail (yalnızca object storage görselleri; harici CDN görselleri zaten hızlı).
export const thumbUrl = (img) => {
  if (!img) return "";
  if (img.startsWith("/api/files/")) {
    return `${BACKEND}${img.replace("/api/files/", "/api/thumb/")}`;
  }
  if (img.startsWith("http")) return img;
  return `${BACKEND}${img}`;
};
